<template>
  <v-container fluid>
        <v-alert v-if="erros" type="error">
          {{ erros }}
        </v-alert>
        <v-layout column>
          <v-row>
            <v-col md-3>
              <v-card>
                <v-card-text>
                  <v-flex class="mb-4 d-flex justify-center">
                    <v-avatar size="150" class="mr-4" min-height="150">
                      <v-img v-if="avatar" :src="avatar.preview"></v-img>
                    </v-avatar>
                  </v-flex>
                  <v-flex class="d-flex justify-center">
                    <v-btn
                      color="success"
                      class="text-none"
                      rounded
                      depressed
                      @click="buscarImagemFile"
                    >
                      Buscar
                    </v-btn>
                    <input
                      ref="uploader"
                      class="d-none"
                      type="file"
                      accept="image/x-png,image/gif,image/jpeg"
                      @change="avatarAlterado"
                    >
                    <v-btn
                      color="success"
                      class="text-none"
                      rounded
                      depressed
                      @click="removerImagem"
                    >
                      Excluir
                    </v-btn>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md-9>
              <v-card>
                  <v-card-text>
                    <v-text-field 
                      :disabled="perfil"
                      v-model="$v.form.ds_email.$model"
                      :error-messages="validacaoForm($v.form.ds_email, 'E-mail')"
                      label="E-mail" 
                      v-lowercase-only>
                    </v-text-field>
                    <v-text-field
                      v-model="password"
                      :append-icon="showPwd1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPwd1 ? 'text' : 'password'"
                      name="input-password"
                      label="Senha"
                      @click:append="showPwd1 = !showPwd1"
                    ></v-text-field>
                    <v-text-field
                      v-model="password_confirmation"
                      :append-icon="showPwd2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPwd2 ? 'text' : 'password'"
                      name="input-password_confirmation"
                      label="Confirme a Senha"
                      @click:append="showPwd2 = !showPwd2"
                    ></v-text-field>
                    <v-select
                      v-if="!perfil"
                      v-model="$v.form.tp_usuario.$model"
                      :items="tipoUser"
                      :error-messages="validacaoForm($v.form.tp_usuario, 'Usuário')"
                      label="Tipo Usuário"
                    ></v-select>
                    <v-select
                      v-if="!perfil"
                      v-model="$v.form.pessoa_id.$model"
                      :items="dropDownColaboradores"
                      :error-messages="validacaoForm($v.form.pessoa_id, 'Colaborador')"
                      label="Colaborador"
                    ></v-select>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-layout>
  </v-container>
</template>

<script>

import {required, minLength, maxLength, email} from 'vuelidate/lib/validators'
import validacaoForm from '@/mixins/validacaoForm'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import logopdf from "@/assets/logo-pdf.png"
import procImages from '@/mixins/procImages'


export default {
  name: 'CadastroUsuario',
  mixins:[validacaoForm, procImages],
  props: {
    perfil: {
      type: Boolean,
      default: true,
    }
  },
  data () {
    return {
      showPwd1: false,
      password: null,
      showPwd2: false,
      password_confirmation: null,
      selectedFile: null,
      isSelecting: false,
      valid: true,
      loading: false,
      form: {},
      dropDownColaboradores: [],
      avatar: null,
      tipoUser: [{ value: 'sAdm', text: 'Super Usuário' } , { value: 'adm', text: 'Administrador' } , 
      { value: 'user', text: 'Usuário' }, { value: 'userCap', text: 'Captacao' }, { value: 'juridico', text: 'Juridico' }]
    }
  },
  validations: {
    form: {
      ds_email: {required, email, errors: [] },
      tp_usuario: { required, errors: []},
      pessoa_id: { errors: [] }, 
    },
  },
  async created() {
    this.montaTpUsuario()
    await this.sincronizaUsuario(this.usuarioSelecionado)
    this.dropDownColaboradores = this.getDropDownColaborador();
  },
  beforeDestroy() {
  },
  computed: {
    ...mapState('usuario', [
      'usuarioSelecionado',
      'erros',
    ])
  },
  watch: {
    usuarioSelecionado(novo, antigo) {
      this.sincronizaUsuario(novo)
    },
    erros(novo, antigo) {
      return novo
    }
  },
  methods: {
    ...mapActions({
      actStoreUsuario: 'usuario/STORE_USUARIO',
      actUsuarioSelecionado: 'usuario/USUARIO_SELECTED',
    }),
    ...mapGetters({
      getErros: 'usuario/GET_ERROS',
      getDropDownColaborador: 'colaborador/GET_DROPDOWN',
    }),
    ...mapMutations({
      commitErro: 'usuario/SET_ERROS',
      resetErros: 'usuario/ERASE_ERROS',
    }),
	  montaTpUsuario() {
		let user = this.$store.state.login.user
		if (user.tp_usuario !== "sAdm") {
      this.tipoUser = [{ value: 'adm', text: 'Administrador' } , { value: 'user', text: 'Usuário' }, 
        { value: 'userCap', text: 'Captacao' }, { value: 'juridico', text: 'Juridico' }]
		}
	},
    buscarImagemFile() {
      window.addEventListener('focus', () => {
      }, { once: true })

      this.$refs.uploader.click()
    },
    removerImagem() {
      this.avatar = null
    },
    async avatarAlterado(e) {
      var file = e.target.files[0]

      //let extensao = file.name.split('.').pop();
      let img = { isEnviar: true, isErro: false }

      //redimensionar e reajusta qualidade da imagem
      try {
        file = await this.resizeImage(file, 640, 480)
      } catch (error) {
        this.$toaster.error(`Erro ao tentar comprimir imagem ${file.name}`)
        reject (error)
      }

      //gera preview e redimensiona imagens
      try {
        const newFile = await this.geraArquivoUpload(file)
        img.preview = newFile.preview
        img.ext = newFile.extensao
        this.avatar = img
        return

      } catch(e) {
        this.$toaster.error(e);
        console.log(e)
        return

      }
    },
    async gravar () {
      this.loading = "success"
      if (!(await this.validaForm())) {
        this.loading = false
        return
      }     
      if (!(await this.store())) {
        this.$toaster.error('Erro ao gravar!');
        return
      }
      this.$toaster.success('Gravação efetuada com sucesso!');
      //this.$emit('close')
    },
    validaForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        return true
      } else if (this.$v.form.$anyError) {
        return false
      }
    },
    sincronizaUsuario (usuario) {
      this.form = Object.assign({}, usuario)
      if (usuario.foto) {
        this.avatar = {}
        this.avatar.preview = usuario.foto
      }
    },
    async store () {
      try {
        var usuario = {}
        usuario.id = this.form.id
        usuario.ds_email = this.form.ds_email
        usuario.tp_usuario = this.form.tp_usuario
        usuario.pessoa_id = this.form.pessoa_id
        if (this.avatar && this.avatar.isEnviar) {
          usuario.file = this.avatar.preview
          usuario.ext = this.avatar.ext
        } else if (!this.avatar) {
          usuario.isAvatarNull = true
        }
        if (this.password !== null) usuario.password = this.password
        if (this.password_confirmation !== null) usuario.password_confirmation = this.password_confirmation
        await this.actStoreUsuario(usuario)
        if (this.erros) return false
        //await (this.actUsuarioSelecionado(usuario.id))
        return true
      } catch (e) {
        console.log(e)
        this.commitErro({erros: "Erro ao enviar dados para Api 'store'" })
        return false
      } finally {
        this.loading = false
      }
    }
  }
}

</script>

<style scoped>
  .v-btn {
    padding: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/Usuario/CadastroUsuario.vue